export default "__VITE_ASSET__DJnEaY8A__"